import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { Icon } from '../Icon/Icon.js';
import { getButtonClasses, getAppearanceClasses, createButton } from '../Button/util.js';

const IconButton = /*#__PURE__*/forwardRef(function IconButton(props, ref) {
  const {
    icon,
    rounded = false,
    ...otherProps
  } = props;
  const className = cn('w-8', getButtonClasses(), getAppearanceClasses(otherProps.appearance, true), {
    'rounded-full': rounded,
    rounded: !rounded,
    'cursor-not-allowed opacity-50': props.disabled,
    'focus:yt-focus active:focus:yt-focus': !props.disabled
  }, props.className);

  if (!icon) {
    return null;
  }

  return createButton({ ...otherProps,
    children: createElement(Icon, {
      name: icon,
      className: "m-0 p-0"
    }),
    'data-taco': 'icon-button'
  }, className, ref);
});

export { IconButton };
//# sourceMappingURL=IconButton.js.map
